<template>
  <span class="vsm-status-row-actions">
    <vsm-reload-button @click="$emit('reload')" />
  </span>
</template>

<script>
import VsmReloadButton from './VsmReloadButton.vue'

export default {
  name: 'VsmStatusRowActions',
  components: {
    VsmReloadButton,
  },
}
</script>
